import React from "react";

export default function MetricsWidgetV2(props) {
  return (
    <div
      className="metrics-widget-container-v2"
      style={{ "--metric-accent": props.backgroundColor }}
    >
      <div className="metrics-widget-v2-label">{props.title}</div>
      <div className="metrics-widget-v2-value">{props.value}</div>
      <div className="metrics-widget-v2-subtitle">{props.title2}</div>
    </div>
  );
}
